import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { CustomResponseDto } from '@core/model/custom-response-dto';

@Injectable()
export class EmailVerificationService {
  private apiUrl = environment.apiUrl;
  private getAccountByEmailUrl = `${this.apiUrl}origination/originations/exists-account-by-email/{email}`;
  private validateEmailUrl = `${this.apiUrl}origination/originations/validate-email-address/{emailAddress}`;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public accountExistsByEmail(email: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<CustomResponseDto<boolean>>(this.getAccountByEmailUrl.replace('{email}', email), {
      headers: this.headers,
    });
  }

  public validateEmail(emailAddress: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<CustomResponseDto<boolean>>(this.validateEmailUrl.replace('{emailAddress}', emailAddress), {
      headers: this.headers,
    });
  }
}
